export default __webpack_public_path__ + "static/19-eeda999e60ad82db58cc96bc40b420da.jpg";